import React, {useEffect, useState} from 'react';
import {Link} from "react-router-dom";
import SideBar from "../../../common/SideBar";
import NavBar from "../../../common/NavBar";
import ManagerService from "../../../services/ManagerService";
import {toast, ToastContainer} from "react-toastify";
import 'react-toastify/dist/ReactToastify.css';
import Spinner from "reactjs-simple-spinner";
import isEmail from "validator/lib/isEmail";
import TextField from "@material-ui/core/TextField";
import InputAdornment from "@material-ui/core/InputAdornment";
import Select from "@material-ui/core/Select";


const EditManager = () => {

    const [name, setName] = useState('');
    const [surname, setSurname] = useState('');
    const [email, setEmail] = useState('');
    const [branch, setBranch] = useState('');
    const [contact_number, setContactNumber] = useState('');
    const [loading, setLoading] = useState(false);

    const [nameError, setNameError] = useState(false);
    const [nameErrorMsg, setNameErrorMsg] = useState('');
    const [branchError, setBranchError] = useState(false);
    const [branchErrorMsg, setBranchErrorMsg] = useState('');
    const [lastNameError, setLastNameError] = useState(false);
    const [lastNameErrorMsg, setLastNameErrorMsg] = useState('');
    const [emailError, setEmailError] = useState(false);
    const [emailErrorMsg, setEmailErrorMsg] = useState('');
    const [contactError, setContactError] = useState(false);
    const [contactErrorMsg, setContactErrorMsg] = useState('');
    const [error, setError] = useState(false);


    useEffect(() => {
        const id = JSON.parse(localStorage.getItem('managerId'));
        ManagerService.getManagerDetails(id).then(response => {
            console.log(response);
            setName(response.manager.name)
            setSurname(response.manager.surname);
            setEmail(response.manager.email)
            setBranch(response.manager.branch);
            setContactNumber(response.manager.contact_number)
        }).catch(err => {
            console.log(err);
        });

    }, []);

    const handleChangeName = (e) => {
        console.log(e.target.value)
        setName(e.target.value);
    }

    const handleChangeSurname = (e) => {

        console.log(e.target.value)
        setSurname(e.target.value);
    }
    const handleChangeEmail = (e) => {
        if (!isEmail(e.target.value)) {
            setEmailError(true)
            setEmailErrorMsg('Email not valid')
            setError(true);
        } else {
            setEmailError(false)
            setEmailErrorMsg('')
        }
        console.log(e.target.value)
        setEmail(e.target.value)
    }
    const handleChangeBranch = (e) => {

        console.log(e.target.value)
        setBranch(e.target.value);
    }
    const handleChangeContactNumber = (e) => {
        if (e.target.value === '') {
            setContactError(true)
            setContactErrorMsg('Field is required')
            setError(true);
        }
        if (e.target.value.length < 9) {
            setContactError(true)
            setContactErrorMsg('Mobile number must be a 9 digit number')
        } else {
            setContactError(false)
            setContactErrorMsg('')
        }
        console.log(e.target.value)
        setContactNumber(e.target.value);
    }
    const handleSubmit = (e) => {
        e.preventDefault();
        // validate inputs
        if (contact_number === '') {
            setContactError(true)
            setContactErrorMsg('Field is required')
            setError(true);
            return;
        }
        if (contact_number.length < 9) {
            setContactError(true)
            setContactErrorMsg('Mobile number must be a 9 digit number')
            return;
        }
        if (branch === '') {
            setBranchError(true)
            setBranchErrorMsg('Field is required')
            setError(true);
            return;
        }
        if (email === '') {
            setEmailError(true)
            setEmailErrorMsg('Field is required')
            setError(true);
            return;
        }
        if (!isEmail(email)) {
            setEmailError(true)
            setEmailErrorMsg('Email not valid')
            setError(true);
            return;
        }
        if (name === '') {
            setNameError(true)
            setNameErrorMsg('Field is required')
            setError(true);
            return;
        }
        if (surname === '') {
            setLastNameError(true)
            setLastNameErrorMsg('Field is required')
            setError(true);
            return;
        }
        //reset error messages
        setError(false)
        setEmailError(false);
        setNameError(false);
        setLastNameError(false);
        setContactError(false);
        setBranchError(false);
        setLoading(true);
        let data = {
            'managerId': JSON.parse(localStorage.getItem('managerId')),
            'name': name,
            'surname': surname,
            'email': email,
            'branch': branch,
            'contact_number': contact_number
        }
        console.log(data);

        ManagerService.updateManager(data)
            .then(res => {
                if(res.status === 200){
                    toast('Manager Updated Successfully', {
                        position: "top-right",
                        autoClose: 3000,
                        hideProgressBar: false,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: true,
                        progress: undefined,
                    });
                    setLoading(false);
                }else{
                     toast.warning('Operation Failed', {
                         position: "top-center",
                         autoClose: 3000,
                         hideProgressBar: false,
                         closeOnClick: true,
                         pauseOnHover: true,
                         draggable: true,
                         progress: undefined,
                     });
                    setLoading(false);
                }
            })
            .catch(err => {
                setLoading(false);
                toast.warning('Operation Failed, error:' + err, {
                    position: "top-center",
                    autoClose: 3000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                });
                console.log(err);
        })


    }

    return (
        <div>
            <ToastContainer
                position="top-center"
                autoClose={3000}
                hideProgressBar={false}
                newestOnTop={false}
                closeOnClick
                rtl={false}
                pauseOnFocusLoss
                draggable
                pauseOnHover
            />
            <SideBar roles={JSON.parse(localStorage.getItem('roles'))}/>
            <div id="main-content" className="main-panel ps-container ps-theme-default">
              <NavBar roles={JSON.parse(localStorage.getItem('roles'))}/>
                <div className="content">
                    <div className="container-fluid">
                        <ul className="breadcrumb">
                            <Link to="/dashboard"><a href><i className="fa fa-home"/>&nbsp;Dashboard</a> </Link>
                            &nbsp;|&nbsp;
                            <Link to="/managers"><a href><i className="fa fa-users-cog"></i>&nbsp;Managers</a></Link>
                            &nbsp;|&nbsp;
                            Edit &nbsp; {name} {surname}

                        </ul>
                        <div className="row mt">
                            <div className="col-lg-12">
                                <div className="card">
                                    {loading && (
                                        <div className="mr-5 ml-5 mt-5 mb-5 p-5">
                                            <Spinner
                                                size="large"
                                                message="Please wait....."
                                                line-fg-color="#64c3c2"
                                            />
                                        </div>

                                    )}
                                    {!loading && (
                                        <form id="agentData" onSubmit={handleSubmit}>
                                            <div id="form-style">
                                                <div className="form-row">
                                                    <div className="form-group col-md-3">
                                                        <label>Name</label>
                                                        <TextField
                                                            error={nameError}
                                                            helperText={nameErrorMsg}
                                                            required
                                                            autoFocus
                                                            margin="dense"
                                                            label="FirstName"
                                                            type="text"
                                                            fullWidth
                                                            value={name}
                                                            inputProps={{style: {textTransform: 'capitalize'}}}
                                                            onChange={handleChangeName}
                                                        />

                                                    </div>

                                                    <div className="form-group col-md-3">
                                                        <label>Surname</label>
                                                        <TextField
                                                            error={lastNameError}
                                                            helperText={lastNameErrorMsg}
                                                            required
                                                            margin="dense"
                                                            label="LastName"
                                                            type="text"
                                                            fullWidth
                                                            value={surname}
                                                            inputProps={{style: {textTransform: 'capitalize'}}}
                                                            onChange={handleChangeSurname}
                                                        />

                                                    </div>
                                                    <div className="form-group col-md-3">
                                                        <label>Email</label>
                                                        <TextField
                                                            error={emailError}
                                                            helperText={emailErrorMsg}
                                                            required
                                                            margin="dense"
                                                            label="Email"
                                                            type="email"
                                                            fullWidth
                                                            inputProps={{style: {textTransform: 'lowercase'}}}
                                                            value={email}
                                                            onChange={handleChangeEmail}
                                                        />

                                                    </div>
                                                    <div className="form-group col-md-3">
                                                        <label>Contact</label>
                                                        <TextField
                                                            error={contactError}
                                                            helperText={contactErrorMsg}
                                                            required
                                                            margin="dense"
                                                            label="Contact Number"
                                                            type="number"
                                                            fullWidth
                                                            value={contact_number}
                                                            onChange={handleChangeContactNumber}
                                                            onInput={(e) => {
                                                                e.target.value = Math.max(0, parseInt(e.target.value)).toString().slice(0, 9)
                                                            }}
                                                            InputProps={{
                                                                startAdornment: <InputAdornment position="start">
                                                                    +263
                                                                </InputAdornment>
                                                            }}
                                                        />

                                                    </div>
                                                    <div className="form-group col-md-3">
                                                        <label>Branch: {branch}</label>
                                                        <Select className="form-control" onChange={handleChangeBranch}
                                                                name="branch">
                                                            <option value='Harare'>Harare</option>
                                                            <option value='Bulawayo'>Bulawayo</option>
                                                        </Select>
                                                        {branchError && (
                                                            <span className="text-danger">{branchErrorMsg}</span>
                                                        )}

                                                    </div>
                                                </div>

                                                <div className="form-row">
                                                    <div className="form-group col-md-12">
                                                        <Link to="/managers">
                                                            <button className="btn btn-info btn-sm">
                                                                <i className="fa fa-backward"/>&nbsp;&nbsp;Back
                                                            </button>

                                                        </Link>

                                                        <button
                                                            type="submit"
                                                            id="editManager"
                                                            className="btn btn-success btn-sm ld-ext-right"
                                                        >
                                                            Update
                                                            &nbsp;&nbsp;<i className="fa fa-send"/>&nbsp;&nbsp;
                                                            <span
                                                                className="ld ldld bare"
                                                                style={{width: 10, height: 10}}
                                                            />
                                                        </button>
                                                    </div>
                                                </div>
                                            </div>
                                        </form>
                                    )}
                        </div>
                    </div>
                </div>
            </div>
        </div>
</div>
</div>

    )
}

export default EditManager;
